var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { staticClass: "stit" }, [_vm._v(_vm._s(_vm.data.alias))]),
    _vm._v(" " + _vm._s(_vm.data.acno) + " (" + _vm._s(_vm.data.cncycd) + ") "),
    _c("div", { staticClass: "amount highlight" }, [
      _c("span", { staticClass: "exchange-unit" }, [
        _vm._v(_vm._s(_vm.data.cncycd))
      ]),
      _c("span", {
        staticClass: "total",
        domProps: { innerHTML: _vm._s(_vm.$num(_vm.data.dpostBal)) }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }